import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ExtensionsListModule } from "../../shared/components/extensionsList/extensions-list.module";
import { HeaderModule } from "../../shared/components/layout/header/header.module";
import { ThreeColumnModule } from "../../shared/components/layout/threeColumn/three-column.module";
import { PhoneNumberListModule } from "../../shared/components/phoneNumberList/phone-number-list.module";
import { SipAddressFieldModule } from "../../shared/components/sipAddressField/sip-address-field.module";
import { TableModule } from "../../shared/components/table/onsip-table.module";
import { TableDataLoadContainerModule } from "../../shared/components/tableDataLoadContainer/table-data-load-container.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { ExternalSipAddressRoutingModule } from "./external-sip-address-routing.module";
import { ExternalSipAddressComponent } from "./external-sip-address.component";
import { ExternalSipAddressSetupComponent } from "./externalSipAddressSetup/external-sip-address-setup.component";
import { ExternalSipAddressShelfEditComponent } from "./externalSipAddressShelfEdit/external-sip-address-shelf-edit.component";
import { ExternalSipAddressShelfViewComponent } from "./externalSipAddressShelfView/external-sip-address-shelf-view.component";
import { ExternalSipAddressTableComponent } from "./externalSipAddressTable/external-sip-address-table.component";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ExternalSipAddressRoutingModule,
    TranslateModule,
    HeaderModule,
    FormsModule,
    ReactiveFormsModule,
    TableDataLoadContainerModule,
    TableModule,
    PipesModule,
    SipAddressFieldModule,
    PhoneNumberListModule,
    ExtensionsListModule,
    ThreeColumnModule,

    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIconModule,
    LoadingContainerComponent
  ],
  declarations: [
    ExternalSipAddressComponent,
    ExternalSipAddressTableComponent,
    ExternalSipAddressSetupComponent,
    ExternalSipAddressShelfEditComponent,
    ExternalSipAddressShelfViewComponent
  ]
})
export class ExternalSipAddressModule {}
